import React, { useState, useEffect } from 'react';
import { useGameContext } from '../GameContext';

import tickSound from './assets/tick.mp3'
import ringSound from './assets/feature.mp3'
import item1Sound from './assets/item1.mp3'
import item2Sound from './assets/item2.mp3'
import item3Sound from './assets/item3.mp3'
import smallWinSound from './assets/small_win.mp3'

import img10 from './assets/slot-icons/10.png';
import imgF from './assets/slot-icons/f.png';
import imgJack from './assets/slot-icons/jack.png';
import imgKey from './assets/slot-icons/key.png';
import imgKing from './assets/slot-icons/king.png';
import imgLexus from './assets/slot-icons/lexus.png';
import imgPistons from './assets/slot-icons/pistons.png';
import imgQueen from './assets/slot-icons/queen.png';

const images = [img10, img10, img10, img10, img10,
                imgF, imgF, 
                imgJack, imgJack, imgJack, imgJack, 
                imgKey, imgKey, imgKey, 
                imgKing, imgKing, 
                imgLexus,
                imgPistons, imgPistons, imgPistons,
                imgQueen, imgQueen,
            ]

function Slots() {
    const { isSpinning, stopSpin } = useGameContext();
    const [reels, setReels] = useState(Array(5).fill(null).map(() => 
        Array.from({ length: 100 }, () => images[Math.floor(Math.random() * images.length)])
    ));
    const [reelsSpinning, setReelsSpinning] = useState(Array(5).fill(false));
    

    const { gameState, updateWinAmount } = useGameContext();
    useEffect(() => {
        if(isSpinning){
            const tick = new Audio(tickSound);
            const item1 = new Audio(item1Sound);
            const item2 = new Audio(item2Sound);
            const item3 = new Audio(item3Sound);
            var itemsCollected = 0;

            const newReels = Array(5).fill(null).map(() => 
                Array.from({ length: 100 }, () => images[Math.floor(Math.random() * images.length)])
            );
            setReels(newReels);


            setReelsSpinning(Array(5).fill(true));

            setTimeout(() => {
                tick.play();
                setReelsSpinning([false,true,true,true,true]);
                for(let i=0; i<3; i++){
                    if(newReels[0][i].includes('lexus.')){
                        if(itemsCollected ===  0){
                            item1.play();
                            itemsCollected++;
                        } else if(itemsCollected === 1){
                            item2.play();
                            itemsCollected++;
                        } else {
                            item3.play();
                        }
                    }
                }
                setTimeout(() => {
                    tick.play();
                    setReelsSpinning([false,false,true,true,true]);
                    for(let i=0; i<3; i++){
                        if(newReels[1][i].includes('lexus.')){
                            if(itemsCollected === 0){
                                item1.play();
                                itemsCollected++;
                            } else if(itemsCollected === 1){
                                item2.play();
                                itemsCollected++;
                            } else {
                                item3.play();
                            }
                        }
                    }
                    setTimeout(() => {
                        tick.play();
                        setReelsSpinning([false,false,false,true,true]);
                        for(let i=0; i<3; i++){
                            if(newReels[2][i].includes('lexus.')){
                                if(itemsCollected === 0){
                                    item1.play();
                                    itemsCollected++;
                                } else if(itemsCollected === 1){
                                    item2.play();
                                    itemsCollected++;
                                } else {
                                    item3.play();
                                }
                            }
                        }
                        setTimeout(() => {
                            tick.play();
                            setReelsSpinning([false,false,false,false,true]);
                            for(let i=0; i<3; i++){
                                if(newReels[3][i].includes('lexus.')){
                                    if(itemsCollected === 0){
                                        item1.play();
                                        itemsCollected++;
                                    } else if(itemsCollected === 1){
                                        item2.play();
                                        itemsCollected++;
                                    } else {
                                        item3.play();
                                    }
                                }
                            }
                            setTimeout(() => {
                                tick.play();
                                setReelsSpinning(Array(5).fill(false));
                                for(let i=0; i<3; i++){
                                    if(newReels[4][i].includes('lexus.')){
                                        if(itemsCollected === 0){
                                            item1.play();
                                            itemsCollected++;
                                        } else if(itemsCollected === 1){
                                            item2.play();
                                            itemsCollected++;
                                        } else {
                                            item3.play();
                                        }
                                    }
                                }


                                var lexusCount = 0;
                                var fCount = 0;
                                var keyCount = 0;
                                
                                newReels.forEach(reel => {
                                    for(let i=0; i<3; i++){
                                        if(reel[i].includes('lexus.')){lexusCount++};
                                        if(reel[i].includes('f.')){fCount++};
                                        if(reel[i].includes('key.')){keyCount++};
                                    }
                                });
                                
                                var bet = gameState.currentBet;

                                if(lexusCount>=3){
                                    setTimeout(() => {
                                        const ring = new Audio(ringSound);
                                        ring.play();
                                        setTimeout(() => {
                                            updateWinAmount(bet*50);
                                            stopSpin();
                                        },3000);
                                    }, 1500);
                                } else if(fCount>=3){
                                    const sound = new Audio(smallWinSound);
                                    sound.play();
                                    updateWinAmount(bet*12);
                                    setTimeout(() => {
                                        stopSpin();
                                    },1000);
                                } else if(keyCount>=5){
                                    const sound = new Audio(smallWinSound);
                                    sound.play();
                                    updateWinAmount(bet*4);
                                    setTimeout(() => {
                                        stopSpin();
                                    },1000);
                                } else {
                                    stopSpin();
                                }
                            },500);
                        },500);
                    },500);
                },500);
            },1500);
        }
    }, [isSpinning]);
    

    return (
        <div className='slots'>
            {reels.map((reel, index) => (
                <div key={index} className={`reel ${reelsSpinning[index] ? 'spinning' : ''}`}>
                    {reel.map((image, idx) => (
                        <img key={idx} src={image} className='slot-item' alt='slot item'/>
                    ))}
                </div>
            ))}
        </div>
    )
}

export default Slots;